var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.48114,14.19751a14.94415,14.94415,0,0,0,1.32916-2.1972C18.9632,10.27606,16.4165,6,12,6a6.60036,6.60036,0,0,0-1.53534.181L8.87659,4.593A8.59653,8.59653,0,0,1,12,4c7,0,10,8,10,8a16.23728,16.23728,0,0,1-2.09015,3.62622ZM5.4425,6.85657,3.293,4.707,4.707,3.293,10.72211,9.308a2.966,2.966,0,0,1,1.27832-.29681,3.00344,3.00344,0,0,1,3,3,2.96588,2.96588,0,0,1-.29682,1.27832L20.707,19.293,19.293,20.707l-2.28668-2.28668A8.74508,8.74508,0,0,1,12,20C5,20,2,12,2,12A16.02135,16.02135,0,0,1,5.4425,6.85657ZM12,18a6.73033,6.73033,0,0,0,3.54938-1.03656l-2.25666-2.25665a2.96517,2.96517,0,0,1-1.29229.30444,3.00343,3.00343,0,0,1-3-3,2.96525,2.96525,0,0,1,.30444-1.2923L6.86047,8.27454a13.8478,13.8478,0,0,0-2.67083,3.72509C5.0368,13.72394,7.5835,18,12,18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.53265b22.svg";
export { ForwardRef as ReactComponent };